import api from '../api'
import mixins from '@/helper/mixins.js'

import baseInfo from '../components/baseInfo.vue' // 基本信息
import financeInfo from '../components/financeInfo.vue' // 融资合同
import forfaitMsg from '../components/forfaitMsg.vue' // 福费廷协议 信息
import invoiceTransfer from '../components/invoiceTransfer.vue' // 发票转让

import ZCollapse from '@/components/ZCollapse'
import ZCard from '@/components/ZCard'
import Tbutton from '@/components/Tbutton/index'
import VerifyPopup from '@/components/VerifyPopup/index'
import ConfirmPopup from '@/components/ConfirmPopup/index'
// import dayjs from "dayjs";
export default {
  name: 'loanDetail',
  mixins: [mixins],
  components: {
    ZCollapse,
    ZCard,
    Tbutton,
    VerifyPopup,
    ConfirmPopup,
    baseInfo,
    financeInfo,
    forfaitMsg,
    invoiceTransfer
  },
  data() {
    return {
      api,
      hideStatus: [100, 101], // 需要隐藏船期的状态
      menuType: 4, // 来源菜单类型 1申请风控 2资金锁定 3贷款发放 4贷后跟踪 5资金池 6全部订单
      menuMsg: {
        path: '',
        name: ''
      },
      index: 0, // 当前选中的tab index

      cicTradeContractSnapshotList: [], // cic合同
      cicDepositInfoSnapshotList: [], // 定金资料

      financeData: {}, // 融资合同数据
      baseDataOne: {}, // 申请基本信息数据 贸易信息+融资基础信息
      baseDataTwo: {}, // 申请基本信息数据 评级+风控
      baseDataFinance: '', // 申请基本信息数据 当前融资情况+最近10笔融资申请+最近10笔订单

      btnLimit: {}, // 按钮权限
      pageSize: 5, // 审核表格数据默认展示条数
      f_n: '', // 融资流水号
      applyStatus: {
        '1': this.$t('loan.buyContract'),
        '2': this.$t('loan.saleContract'),
        '3': this.$t('loan.terminalContract')
      },
      addFileList: [], // 补充资料

      tradeLog: [], // 贸易审核记录 数据
      tradePage: {
        pageNo: 1,
        total: 0
      }, // 贸易合同审核记录表格及对应的分页
      newzmaCredit: [],
      zmaCredit: [], // 船期列表
      zmaCreditId: [], // 船期id集合
      zmaShow: [], // 船期收起展开集合
      zmaType: {
        '1': this.$t('loan.purchaseInfo'),
        '2': this.$t('loan.salesInfo')
      },
      zmaStatusList: ['A. ' + this.$t('loan.loanCheck'), 'B. ' + this.$t('loan.infoCheck'), 'C. ' + this.$t('newrisk.waterCheck'), 'D. ' + this.$t('loan.refundCheck'), 'E. ' + this.$t('status.170')], // 船期放款状态集合
      loanStatusList: ['A. ' + this.$t('loan.loanCheck'), 'B. ' + this.$t('newrisk.fortingCheck'), 'C. ' + this.$t('newrisk.waterCheck'), 'D. ' + this.$t('loan.refundCheck'), 'E. ' + this.$t('status.170')], // 放款状态集合

      lendingLog: [], // 船期 放款审核记录
      pagingParm: {
        pageNo: 1,
        total: 6
      },
      loanType: '',
      loanTypeText: ['', this.$t('newrisk.p_financing'), this.$t('newrisk.r_financing'), this.$t('newrisk.pr_financing')],
      loanForm: '', // 放款资料审核-贷款发放资料表单信息
      invoiceForm: '', // 放款资料审核-发票转让表单信息

      actionParam: {
        status: this.defaultStatus, // 当前船期状态
        action: '', // 当前操作
        a_o: '', // 审核意见
        f_i: '' // 船期id
      }, // 审核 确认操作提交 入参信息

      isVerifyShow: false, // 是否展示审核弹框
      verifyTitle: '', // 审核弹框 title
      isConfirmShow: false, // 是否展示二次确认框
      confirmTitle: '', // 二次确认弹框 title

      repulse: [1, 102, 103, 104, 109, 110, 140, 150, 160, 1003, 1004, 1005, 1011, 1012, 1013], // 展示 打回 按钮的状态， 去掉 113 水单审核
      pass: [1, 103, 104, 109, 110, 150, 160, 1004, 1005, 1012, 1013], // 展示 通过 按钮的状态
      submit: [102, 108, 140, 1003, 1006, 1011], // 展示 提交 按钮的状态， 去掉 113 水单审核
      refuseLend: [104, 1005], // 拒绝放款

      defaultStatus: '', // 默认第一个船期的 status
      defaultId: '', // 默认第一个船期的 id

      comData: '', // 公共信息
      authStatus: [] // 状态权限集
    }
  },
  computed: {
    contract() {
      return this.sortByKey(this.cicTradeContractSnapshotList, 'applyStatus')
    } // 合同 排序

  },

  methods: {
    /**
     * 获取详情信息接口
     * @param f_n
     */
    getDetail() {
      const _this = this
      const param = {
        f_n: _this.f_n
      }
      let url = ''
      _this.zmaCreditId = []
      _this.zmaShow = []
      if (this.menuType == 3) {
        url = _this.api.loanDetail // 贷款发放 船期 之后的 状态所用的详情接口
      } else {
        url = _this.api.afterLoanDetail // 贷后跟踪详情接口
      }

      // loanDetail  afterLoanDetail
      Promise.all([this.axios.post('/api/zma/mainloan/getdepositInfo', { flowNumber: _this.f_n }),
      this.axios.post('/api/zma/mainloan/getFsSchedule', { flowNumber: _this.f_n }),
      this.axios.post(url, param),
      this.axios.post('/api/zma/loanMenu/getPermissionStatusList')
      ]).then(res => {
        console.log(res)
        if (!res.some(v => !v.status)) {
          this.authStatus = res[3].data
          // console.log(res);
          const data = res[2].data
          _this.cicTradeContractSnapshotList = _this.toArray(data.cicTradeContractSnapshotList) // cic合同
          _this.addFileList = _this.toArray(data.addFileInfoList) // 补充资料
          // _this.zmaCredit = _this.toArray(data.zmaCredit) // 船期列表
          this.loanType = res[2].data.loanType
          res[0].data.forEach(v => {
            res[1].data.forEach(s => {
              if (v.id == s.id) {
                v.cicFsScheduleVOS = s.cicFsScheduleVOS
              }
            })
          })
          this.zmaCredit = res[0].data
          _this.comData = {
            flowNumber: _this.f_n,
            seller: _this.contract.length > 0 ? _this.contract[1].seller : '',
            buyer: _this.contract.length > 0 ? _this.contract[1].buyer : ''
          }

          const zmaCreditStatus = []
          // let finalLoan = 0 // 是否有最终放款
          this.zmaCredit.forEach((v, i) => {
            const isShow = _this.checkBtnLimit(v.loanStatus) && _this.checkBtnSome(v.loanStatus)
            _this.zmaShow.push(isShow)
            this.$set(v, 'show', false)
            if (i === 0) {
              this.$set(v, 'show', true)
            }
            v.applicationStatus = v.loanStatus
            v.zmaCreditCoftInfoVO = (v.zmaCreditCoftInfoVOList && v.zmaCreditCoftInfoVOList.length > 0) ? v.zmaCreditCoftInfoVOList[0] : ''
            zmaCreditStatus.push(v.loanStatus) // 所有船期状态集合
            if (v.zmaCreditCoftInfoVO) {
              v.zmaCreditCoftInfoVO.applicationStatus = v.loanStatus
              v.zmaCreditCoftInfoVO.loanType = 1
              const curLimit = _this.checkBtnLimit(v.loanStatus)
              v.zmaCreditCoftInfoVO = Object.assign(v.zmaCreditCoftInfoVO, _this.comData, { limit: curLimit, finalLoan: v.finalLoan, serialNumber: v.serialNumber }) // 福费廷协议信息
              const invoiceObj = {
                limit: curLimit,
                applicationStatus: v.loanStatus,
                contractNum: v.zmaCreditCoftInfoVO.contractNum,
                finalReceiptNum: v.zmaCreditCoftInfoVO.invoiceNumber,
                invoiceNumberCoft: v.zmaCreditCoftInfoVO.invoiceNumberCoft || ''
              }
              v.cicFsCreditInvoiceInfoVO = Object.assign(v.cicFsCreditInvoiceInfoVOS[0] || {}, _this.comData, invoiceObj) // 发票转让信息
              _this.$nextTick(() => {
                if (_this.$refs.forfaitMsgOut) {
                  _this.$refs.forfaitMsgOut[i].handleInit(v.zmaCreditCoftInfoVO, v.cicFsCreditInvoiceInfoVO)
                }

                if (v.loanStatus === 1006) {
                  if (_this.$refs.invoiceMsgOut) {
                    _this.$refs.invoiceMsgOut[i].handleInit(v.cicFsCreditInvoiceInfoVO)
                  }
                }
              })
            }
            if (v.cicFsScheduleVOS) {
              v.cicFsScheduleVOS.forEach((val, key) => {
                // val.isShow = true;  // 当前船期信息是否展开
                this.$set(val, 'show', true)
                // if (val.finalLoan && val.reviewStatus !== 105 && _this.hideStatus.indexOf(val.reviewStatus) < 0) {
                //   finalLoan = 1
                // }
                val.applicationStatus = val.reviewStatus

                val.zmaCreditCoftInfoVO = (val.zmaCreditCoftInfoVOList && val.zmaCreditCoftInfoVOList.length > 0) ? val.zmaCreditCoftInfoVOList[0] : ''
                console.log(val.zmaCreditCoftInfoVO)

                zmaCreditStatus.push(val.reviewStatus) // 所有船期状态集合
                // console.log('zmaCreditCoftInfoVO --------------------------------');
                // console.log(val.zmaCreditCoftInfoVO);
                if (val.zmaCreditCoftInfoVO) {
                  val.invoiceNumberCoft = ''
                  val.zmaCreditCoftInfoVO.applicationStatus = val.reviewStatus
                  // 预付款的福费廷  非真实loanType
                  val.zmaCreditCoftInfoVO.loanType = 0
                  const curLimit = _this.checkBtnLimit(val.reviewStatus)
                  val.zmaCreditCoftInfoVO = Object.assign(val.zmaCreditCoftInfoVO, _this.comData, { limit: curLimit, finalLoan: val.finalLoan, serialNumber: val.serialNumber }) // 福费廷协议信息
                  const invoiceObj = {
                    limit: curLimit,
                    applicationStatus: val.reviewStatus,
                    contractNum: val.zmaCreditCoftInfoVO.contractNum,
                    finalReceiptNum: val.zmaCreditCoftInfoVO.invoiceNumber
                  }
                  val.cicFsCreditInvoiceInfoVO = Object.assign(val.cicFsCreditInvoiceInfoVOS[0] || {}, _this.comData, invoiceObj) // 发票转让信息
                  _this.$nextTick(() => {
                    console.log(_this.$refs['forfaitMsg' + i + key], '_this.$refs.forfaitMsg')
                    _this.$refs['forfaitMsg' + i + key][0].handleInit(val.zmaCreditCoftInfoVO, val.cicFsCreditInvoiceInfoVO)

                    if (val.reviewStatus === 108) {
                      _this.$refs['invoiceMsg' + i + key][0].handleInit(val.cicFsCreditInvoiceInfoVO)
                    }
                  })
                }

                _this.zmaCreditId.push(val.id)
                // val.deposit = _this.sortByKey(val.cicDepositInfoSnapshotList, 'depositType')
              })
            }
          })
          console.log(_this.zmaShow, 'show')

          // window.sessionStorage.setItem('finalLoan', finalLoan)

          _this.lendingLog = [] // 放款、还款审核记录（船期审核）
          // _this.depositLog = []; // 定金审核记录
          _this.tradeLog = [] // 贸易合同审核记录

          _this.financeData.cicFinancingCostDraftSnapshot = data.cicFinancingCostDraftSnapshot // cic费用
          _this.financeData.zmaFinancingInfo = data.zmaFinancingInfo // 融资信息
          _this.financeData.moneyLockLog = [] // 资金锁定审核记录
          _this.financeData.zmaUpdateTimeLogs = data.zmaUpdateTimeLogs // 资金出入日期
          _this.financeData.zmaLockMoneyLogs = data.zmaLockMoneyLogs // 资金锁定
          _this.financeData.availableBalance = data.zmaFinancingManagement.availableBalance // 资金调整可用余额
          _this.financeData.isComplete = zmaCreditStatus.indexOf(180) > -1

          _this.baseDataOne = data.cicFinancingApplyDraftSnapshot // 贸易信息+融资基础信息
          _this.baseDataTwo.zmaFinancingManagement = data.zmaFinancingManagement // 评级
          _this.baseDataTwo.cicFinancingApplyDraftSnapshot = data.cicFinancingApplyDraftSnapshot

          _this.baseDataTwo.riskLog = [] // 风控审核记录
          _this.baseDataFinance = data.zmaFinancingOrderVo // 融资相关信息

          if (data.zmaAuditLog && data.zmaAuditLog.length > 0) {
            _this._.map(data.zmaAuditLog, (val) => {
              // console.log(val);
              // console.log(key);
              const processType = parseInt(val.processType) // 1. 风控 2.资金锁定 3.放款 4.还款 5.定金 6.贸易合同
              if (processType == 1) {
                this.baseDataTwo.riskLog.push(val)
              }
              if (processType == 2) {
                this.financeData.moneyLockLog.push(val)
              }
              if (processType == 3 || processType == 4 || processType == 7 || processType == 8) {
                this.lendingLog.push(val)
              }
              if (processType == 6) {
                this.tradeLog.push(val)
              }
            })
          }
          _this.tradePage.total = _this.tradeLog.length // 贸易合同审核记录

          if (_this.zmaCredit && _this.zmaCredit.length > 0) {
            _this.defaultStatus = _this.zmaCredit[0].applicationStatus // 默认取第一个船期 状态
            _this.defaultId = _this.zmaCredit[0].id // 默认取第一个船期 状态
          }

          _this.$nextTick(() => {
            _this.$refs.financeInfo.handleInit(_this.financeData)
          })
        } else {
          // console.log(res.errorCode);
          if (res.errorCode == 'loan_audit_5000005' || res.errorCode == 'loan_audit_50000031') {
            _this.isVerifyShow = false
            _this.isConfirmShow = false
            _this.$router.push(this.menuMsg.path)
            // 数据变更跳列表
          } else {
            this.$message.error(this.$t(`error.${res.errorCode}`))
          }
        }
      })
    },

    loanToggle(v) {
      // this.$set(this.zmaShow, index, !this.zmaShow[index])
      this.$set(v, 'show', !v.show)
      console.log(v.show)
    }, // 单个船期 展开收起

    goAnchor(target, v) {
      this.$nextTick(() => {
        const toElement = document.getElementById(target)
        const index = target.split('_')[1]
        // if(target.indexOf('anchorShip')>-1){

        // }
        this.zmaCredit.forEach(s => { s.show = false })
        if (v) {
          v.show = true
        }

        this.$nextTick(() => {
          toElement.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
          }) // 定位到头部
        })
      })

      // this.$nextTick(()=>{
      //   if(target.indexOf('Action')<0){
      //     toElement.scrollIntoView({
      //       block: 'start',
      //       behavior: 'smooth'
      //     }) // 定位到头部
      //   }else{
      //     toElement.scrollIntoView(false) // 定位到底部
      //   }
      // })
    }, // 锚点跳转

    toArray(arr) {
      return Array.isArray(arr) ? arr : []
    },

    checkTab(idx) {
      this.index = idx
    }, // tab切换

    sortByKey(array, key) {
      if (array.length > 0) {
        return array.sort((a, b) => {
          const x = a[key]
          const y = b[key]
          if (x < y) {
            return -1
          }
          if (x > y) {
            return 1
          }
        })
      } else {
        return []
      }
    }, // 合同、定金资料数组排序

    isRepulse(status) {
      return this.repulse.indexOf(status) > -1
    }, // 是否展示 打回
    isPass(status) {
      return this.pass.indexOf(status) > -1
    },
    isSubmit(status) {
      return this.submit.indexOf(status) > -1
    },
    isRefuseLend(status) {
      return this.refuseLend.indexOf(status) > -1
    },
    checkBtnLimit(applicationStatus) {
      // this.btnLimit.zmaCreditIds
      // console.log(zmaCreditId);
      if (this.isSuper()) {
        return true
      }
      return this.authStatus.some(v => v == applicationStatus)
      // let curditLimit = 1
      // // console.log(this.btnLimit);
      // if (this.btnLimit.zmaCreditIds && this.btnLimit.zmaCreditIds.length > 0) {
      //   curditLimit = this._.find(this.btnLimit.zmaCreditIds, { 'id': zmaCreditId })
      //   curditLimit = curditLimit ? curditLimit.status : 0
      //   // console.log(curditLimit);
      // } // 权限中是否存在船期 存在找到id对应的 状态
      // return !!(this.btnLimit.type && curditLimit)
    }, // 校验当前船期是否有 操作权限

    checkBtnSome(status) {
      return (this.isRepulse(status) || this.isPass(status) || this.isSubmit(status) || this.isRefuseLend(status))
    }, // 校验当前船期是否有 可操作按钮
    openVerify(action, id = this.defaultId, status = this.defaultStatus, other) {
      console.log('action:' + action + '+++ status:' + status)
      if (action === 'repulse') {
        this.verifyTitle = this.$t('popTitle.sureRepulse')
      }
      if (action === 'pass') {
        this.verifyTitle = this.$t('popTitle.surePass')
      }
      if (action === 'refuse') {
        this.verifyTitle = this.$t('popTitle.sureReview')
      }

      this.actionParam.action = action
      this.actionParam = { ...this.actionParam, ...other }
      this.actionParam.status = status

      this.isVerifyShow = true
    }, // 打开审核弹框 添加意见 action:当前操作，defaultId：当前船期id，status：当前船期状态

    verifyOk(msg = '') {
      if (this.actionParam.action !== 'pass' && !msg) {
        this.$message.error(this.$t('error.lending_audit_4000003')) // 除了通过外，其他操作审核意见不能为空
        return false
      }
      const param = {
        f_n: this.f_n, // 流水号
        a_o: msg, // 审核意见
        f_i: this.actionParam.scheduleId, // 船期id
        mainLoanId: this.actionParam.mainLoanId,
        loanStatus: this.actionParam.loanStatus,
        scheduleId: this.actionParam.scheduleId,
        zmaCreditId: this.actionParam.scheduleId,
        scheduleStatus: this.actionParam.scheduleStatus,
        dataType: this.actionParam.dataType,

      }
      this.okAjax(param)
    }, // 审核确认

    forfaitSubmit(data) {

      this.loanForm = data

      console.log(data, '福费廷资料')
    }, // 放款审核表单组件返回值

    openConfirm(action, id, status = this.defaultStatus, i, other) {
      console.log('action:' + action + '+++ status:' + status)

      if (status === 102 || status === 108) {
        this.$refs[i][0].handleSubmit()
        if (!this.loanForm) {
          return false
        }
      }
      if (status === 1003 || status === 1006) {
        this.$refs.forfaitMsgOut[i].handleSubmit()
        if (!this.loanForm) {
          return false
        }
      }

      if (action === 'submit') {
        this.confirmTitle = this.$t('popTitle.sureSubmit')
      }
      this.loanForm = { ...this.loanForm, ...other }
      this.loanForm.zmaCreditId = this.loanForm.scheduleId

      this.actionParam.action = action
      this.actionParam.f_i = id
      this.actionParam.status = status

      this.isConfirmShow = true
    }, // 打开二次确认框

    confirmOk() {
      let param = ''
      if (this.actionParam.status === 102 || this.actionParam.status === 1003) {
        param = Object.assign({ flowNumber: this.f_n }, this.loanForm)
      } else if (this.actionParam.status === 108 || this.actionParam.status === 1006) {
        param = this.loanForm
      } else {
        param = {
          f_n: this.f_n, // 流水号
          a_o: '', // 审核意见
          f_i: this.actionParam.f_i, // 船期id
          mainLoanId: this.loanForm.mainLoanId,
          loanStatus: this.loanForm.loanStatus,
          scheduleId: this.loanForm.scheduleId,
          zmaCreditId: this.loanForm.scheduleId,
          scheduleStatus: this.loanForm.scheduleStatus,
          dataType: this.loanForm.dataType

        }
      }
      param.cicCreditId = this.loanForm.scheduleId

      this.okAjax(param)
    }, // 二次确认弹框 确认

    okAjax(param) {
      const _this = this
      const url = api.status[_this.actionParam.status + '_' + _this.actionParam.action]
      console.log(param, 'submit')
      _this.axios.post(url, param).then(res => {
        // console.log(res);
        if (res.status) {
          _this.isVerifyShow = false
          _this.isConfirmShow = false
          _this.$message.success(this.$t('btns.actionSuccess'))
          _this.getDetail()

          const isSuper = this.isSuper()
          if (!isSuper) {
            _this.getBtnLimit(_this.f_n).then(data => {
              // console.log(data);
              _this.btnLimit = data
            }) // 获取按钮权限 判断订单是否展示审核按钮 f_n 融资流水号
          } // 获取按钮权限 判断订单是否展示审核按钮 f_n 融资流水号
        } else {
          if (res.errorCode === 'loan_audit_5000005' || res.errorCode === 'loan_audit_50000031') {
            _this.isVerifyShow = false
            _this.isConfirmShow = false
            _this.$router.push(this.menuMsg.path)
            // 数据变更跳列表
          } else {
            _this.$message.error(this.$t(`error.${res.errorCode}`))
          }
        }
      })
    },

    getLendingLog(zmaCreditId) {
      return this._.filter(this.lendingLog, (val) => {
        return val.zmaCreditId == zmaCreditId
      })
    }, // 获取船期放款审核记录： zmaCreditId 船期id

    getCurStatus(status) {
      // console.log(status);
      if (status >= 102 && status <= 107 && status !== 105) {
        return 0
      } else if (status == 108) { // status>=108 && status<=110 去掉了 福费廷第二部资料的 一审二审
        return 1
      } else if (status >= 111 && status <= 112) { // status<=113 现在没有 水单审核啦
        return 2
      } else if ([120, 130, 140, 150, 160].indexOf(status) > -1) {
        return 3
      } else if ([170, 180].indexOf(status) > -1) {
        return 4
      }
    }, // 获取船期状态信息 放款审核、资料审核、水单审核、还款审核
    getLoanStatus(status) {
      // 0. 放款审核  1.福费廷审核 2. 水单/LC审核 3. 还款审核 4. 还款完毕
      if ([1001, 1002, 1003, 1004, 1005, 1090, 1091, 1093, 1098].indexOf(status) > -1) {
        return 0
      } else if (status == 1006) { // status>=108 && status<=110 去掉了 福费廷第二部资料的 一审二审
        return 1
      } else if ([1007, 1008, 1009, 1010].indexOf(status) > -1) { // status<=113 现在没有 水单审核啦
        return 2
      } else if ([1011, 1012, 1013].indexOf(status) > -1) {
        return 3
      } else if ([1099].indexOf(status) > -1) {
        return 4
      }
    }, // 获取放款状态信息
    viewShipMsg(item) {
      console.log('查看船运信息')
      this.$router.push(
        {
          path: '/logisticMap',
          query: { imo: item.imo, f_n: this.$route.query.f_n, menuType: this.$route.query.menuType }
        }
      )
    }, // 查看船运信息

    // printHandle(){
    //   console.log('打印');
    // }

    dealData(data, type) {
      if (!data || data.length < 1) {
        return []
      }
      const arr = []
      data.forEach((item) => {
        const obj = {}
        if (type === 2) {
          obj.id = item.dangkouID
          obj.name = item.dangkouName
        }
        arr.push(obj)
      })
      return arr
    } // 处理数据
  },
  created() {
    this.f_n = this.$route.query.f_n
    // this.f_n = 'FM15843243099061'; // 测试数据
    this.menuType = this.$route.query.menuType
    if (this.menuType == 3) {
      this.menuMsg.path = '/financingExamineList'
      this.menuMsg.name = this.$t('loanApplication.loanpayment')
    } else if (this.menuType == 4) {
      this.menuMsg.path = '/afterLoanList'
      this.menuMsg.name = this.$t('loanApplication.loanfollow')
    } else if (this.menuType == 6) {
      this.menuMsg.path = '/allorders'
      this.menuMsg.name = this.$t('head.allOrder')
    }
  },
  mounted() {
    const _this = this
    document.title = this.$t('financingDetails.financingaplayBook')
    _this.getDetail()
    const isSuper = this.isSuper()
    if (!isSuper) {
      _this.getBtnLimit(_this.f_n).then(data => {
        // console.log(data);
        _this.btnLimit = data
      }) // 获取按钮权限 判断订单是否展示审核按钮 f_n 融资流水号
    }
  }
}
